import { Pipe, PipeTransform } from '@angular/core';
import { TStatementEvaluationStatus } from '../models/scorecard-section.model';

@Pipe({
  name: 'scorePoints',
  standalone: true,
})
export class ScorePointsPipe implements PipeTransform {
  transform(status: TStatementEvaluationStatus, points: number | null): string | number {
    return status === 'success' || status === 'fail' ? points ?? 0 : '-';
  }
}
